<template>
    <button
        v-if="isButton"
        type="button"
        role="switch"
        :aria-checked="isChecked"
        :disabled="disabled || readonly"
        data-ob1-component="Switch"
        class="ob1-switch ob1-switch-button toggle toggle-rounded labels"
        :class="{'ob1-switch-inverse': isInverse}"
        @click="onChange"
    >
        <span class="on" aria-hidden="true" v-text="onLabel" />
        <span class="off" aria-hidden="true" v-text="offLabel" />
    </button>
    <div
        v-else
        class="ob1-switch"
        :class="{'ob1-switch-inverse': isInverse}"
    >
        <input
            :id="id"
            type="checkbox"
            autocomplete="off"
            class="checkbox visually-hidden"
            :checked="isChecked"
            :disabled="disabled || readonly"
            @change="onChange"
        >
        <label
            :for="id"
            class="toggle toggle-rounded labels"
        >
            <span class="on" v-text="onLabel" />
            <span class="off" v-text="offLabel" />
        </label>
    </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
    name: 'SwitchButton',
    props: {
        id: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false
        },
        checked: {
            type: Boolean,
            required: false,
            default: false
        },
        onLabel: {
            type: String,
            required: false,
            default: "Oui"
        },
        offLabel: {
            type: String,
            required: false,
            default: "Non"
        },
        isInverse: {
            type: Boolean,
            required: false,
            default: false
        },
        isButton: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            isChecked: false,
        }
    },
    watch: {
        checked: {
            immediate: true,
            handler(newValue: boolean | null, _oldValue: boolean | null) {
                this.isChecked = newValue;
            }
        }
    },
    methods: {
        onChange() {
            this.isChecked = !this.isChecked;
            this.$emit("change", this.isChecked);
        }
    }
});
</script>
